// extracted by mini-css-extract-plugin
export default {"certificate-details-tab-view":"CertificateDetailsTabView_certificate-details-tab-view__KL+uH"};